import { cAxios } from '@/utils/axios.js'

const AGENTINFO_API_URL = "/api/user/agentInfo"

class AgentInfoService {

    getAgentInfo() {
        return cAxios
            .get(AGENTINFO_API_URL)
            .then(response => {
                localStorage.setItem('userInfo', JSON.stringify(response.data))
                return response.data;

            }).catch(error => {
                console.log(error.response);
            })
    }

}
export default new AgentInfoService();